module.exports = __webpack_public_path__ + "img/icon-arrow-blue.69c9576d.svg";